import classNames from 'classnames';

type OptionProps = {
  onPicked: () => void;
  isPicked: boolean;
  children: React.ReactNode;
};

const Option = ({ children, isPicked, onPicked }: OptionProps) => {
  return (
    <button
      onClick={() => onPicked()}
      className={classNames(
        'block px-4 py-2 rounded-md mb-2',
        !isPicked
          ? 'bg-white border-2 border-gray-700 text-gray-700'
          : 'border-2 border-transparent bg-pink-500 text-white'
      )}
    >
      {children}
    </button>
  );
};

export default Option;
